<div class="no-record" [style.min-height]="height">
  <div class="no-record__content">
    <img
      [src]="imageSrc"
      [alt]="imageAlt"
      class="no-record__image"
    />

    <h2 *ngIf="title" class="no-record__title">{{ title }}</h2>

    <p *ngIf="description" class="no-record__description">{{ description }}</p>

    <button
      *ngIf="buttonLabel"
      id="no-record-action-btn"
      pButton
      type="button"
      icon="pi pi-plus"
      class="no-record__button"
      [label]="buttonLabel"
      (click)="onButtonClick()"
    ></button>
  </div>
</div>
